// Formatage déterministe (identique serveur et navigateur, sans dépendre de l'ICU).

const NARROW_NBSP = ' '
const NBSP = ' '

export const formatEuro = (value: number, cents = false): string => {
    const fixed = cents ? value.toFixed(2) : Math.round(value).toString()
    const [integer, decimals] = fixed.split('.')
    const grouped = integer.replace(/\B(?=(\d{3})+(?!\d))/g, NARROW_NBSP)

    return `${grouped}${decimals ? `,${decimals}` : ''}${NBSP}€`
}

export const formatHours = (hours: number): string => {
    const totalMinutes = Math.round(hours * 60)
    const h = Math.floor(totalMinutes / 60)
    const m = totalMinutes % 60

    if (h === 0) return `${m}${NBSP}min`
    if (m === 0) return `${h}${NBSP}h`

    return `${h}${NBSP}h${NBSP}${m.toString().padStart(2, '0')}`
}

export const formatClock = (minutes: number): string => {
    const h = Math.floor(minutes / 60)
    const m = minutes % 60

    return m === 0 ? `${h}${NBSP}h` : `${h}${NBSP}h${NBSP}${m.toString().padStart(2, '0')}`
}

export const formatPhone = (digits: string): string => {
    const national = digits.startsWith('+33')
        ? `0${digits.slice(3)}`
        : digits.startsWith('0033') ? `0${digits.slice(4)}` : digits

    return national.replace(/(\d{2})(?=\d)/g, '$1 ')
}
